import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { bffInstance } from "@shared/services";
import { convertObjectToCamelCase, handleApiError } from "@shared/helpers";

import { PAYFAC_QUERIES } from "./queries";

import type { ISellerWithPagination } from "@payfac/types";

const URLS = {
  sellers: `/payfac/v1/sellers`,
};

const api = bffInstance({
  enableBearerToken: false,
  enableXTokenApi: true
});

export interface UseGetSellersListFilters {
  page?: number;
  size?: number;
  search?: string;
  sort?: string;
  fields?: string;
}

export const useGetSellersList = ({
  filters,
}: {
  filters?: UseGetSellersListFilters;
} = {}) => {
  const { t } = useTranslation();

  const getSellersList = async (): Promise<{
    success: boolean;
    message: string;
    data?: ISellerWithPagination;
  }> => {
    try {
      const { data } = await api.get(URLS.sellers, { params: filters });

      return {
        success: true,
        message: t("payfac.pageSellersServiceListSuccess"),
        data: convertObjectToCamelCase(data) as ISellerWithPagination,
      };
    } catch (error: any) {
      return handleApiError(error, t("payfac.pageSellersServiceListError"));
    }
  };

  return useQuery({
    queryKey: [PAYFAC_QUERIES.SELLERS, filters],
    queryFn: () => getSellersList(),
  });
};
